var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"tipo-ocorrencia","rota-base":"/admin/tipo-ocorrencia","titulo-singular":"Tipo de Ocorrência","campos-extras":[
        { campo: "descricao", label: "Descrição", tipo: "text" }
    ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }